import React, { useEffect, useState } from "react";
import { useT } from "@/i18n/LanguageContext";
import SectionHeading from "@/components/SectionHeading";
import api from "@/lib/api";
import { asArray, formatCr } from "@/lib/safeData";
import { Quote, AlertTriangle, Lightbulb, MapPin } from "lucide-react";

const Stories = () => {
  const { t } = useT();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/stories")
      .then((r) => setItems(asArray(r.data)))
      .catch(() => setItems([]));
  }, []);
  const storyList = asArray(items);

  return (
    <div className="mx-auto max-w-7xl px-4 md:px-8 py-16 md:py-24" data-testid="stories-page">
      <SectionHeading eyebrow="Voices from the Ground" title={t.stories.title} subtitle={t.stories.subtitle} />

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
        {storyList.map((s, i) => (
          <article key={s.id ?? `story-${i}`} className="surface-card p-7 relative" data-testid={`story-${s.id ?? i}`}>
            <Quote className="absolute right-6 top-6 h-10 w-10 text-[#D4AF37]/15" />
            <div className="flex items-center gap-3 text-xs">
              <span className="font-mono-alt uppercase tracking-widest text-[#D4AF37]">{s.scam_type}</span>
              <span className="text-white/30">·</span>
              <span className="text-white/50 inline-flex items-center gap-1"><MapPin className="h-3 w-3" /> {s.state}</span>
            </div>
            <h3 className="mt-3 font-display text-xl font-bold leading-snug">{s.title}</h3>
            <p className="mt-3 text-sm text-white/70 leading-relaxed">{s.summary}</p>

            <div className="mt-5 rounded-lg border border-[#D4AF37]/20 bg-[#D4AF37]/[0.04] p-4">
              <div className="text-[10px] uppercase tracking-widest text-[#D4AF37] font-mono-alt inline-flex items-center gap-1.5">
                <Lightbulb className="h-3 w-3" /> {t.stories.lessonLabel}
              </div>
              <div className="mt-1.5 text-sm text-white/80 leading-relaxed">{s.lesson}</div>
            </div>

            <div className="mt-5 flex items-center justify-between border-t border-white/10 pt-4">
              <div>
                <div className="text-[10px] uppercase tracking-widest text-white/40 font-mono-alt">{t.stories.lossLabel}</div>
                <div className="font-mono-alt font-bold text-[#FF6A60]">{formatCr(s.amount_lost)}</div>
              </div>
              <AlertTriangle className="h-5 w-5 text-[#FF3B30]/70" />
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Stories;
